import { faEnvelope } from '@fortawesome/pro-duotone-svg-icons';
import { EmptyState } from '@rocketlane/ui';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const Root = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;
  padding: var(--spacing-09) var(--spacing-08);
`;

/** "Email thread not found" empty state — shared by the emails-v2 page and the email-thread drawer for a stale/deleted thread id. */
export const EmailThreadNotFoundState = () => {
  const intl = useIntl();

  return (
    <Root>
      <EmptyState
        icon={{ icon: faEnvelope }}
        message={intl.formatMessage({
          id: 'account.email_pages.thread_not_found_title',
          defaultMessage: 'Email thread not found',
        })}
        description={intl.formatMessage({
          id: 'account.email_pages.thread_not_found_message',
          defaultMessage:
            'This thread is no longer available. It may have been deleted.',
        })}
      />
    </Root>
  );
};
